import { Button, Dialog, List } from "antd-mobile";
import $ from "jquery";
import React, { useState, useContext, useEffect } from "react";

import { Route, Switch, withRouter } from "react-router-dom";

import PsContext from "../../../context";
import Header from "./header";
import Footer from "./footer";
import webPages from "../webPages";
import admissionInstructions from "../../admissionInstructions";
import login from "../../login";
import signUp from "../../signUp";
import homePage from "../homePage";
import applicationEnquiry from "../applicationEnquiry";
import Registration from "../../registration";
import MobileVerification from "../../mobileVerification";
import RegisterSuccess from "../../registerSuccess";
import AdmissionAlertModal from "../homePage/admissionAlertModal";

const WebLayout = (props) => {
  const context = useContext(PsContext);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.location.pathname]);

  useEffect(() => {
    const checkScrollTop = () => {
      if (window.pageYOffset > 400) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const whatsappNo = context.settingValue("admission_whatsapp_no") || "";

  return (
    <>
      <Header {...props} />

      <div className="floating-actions-container">
        {context.settingValue("admission_whatsapp_no") && (
          <a
            href={`https://wa.me/${String(whatsappNo).replace(/[^0-9]/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="floating-btn btn-whatsapp"
            title="Contact on WhatsApp"
          >
            <i className="fa-brands fa-whatsapp"></i>
          </a>
        )}

        <button
          className={`floating-btn btn-scroll-top ${showScroll ? "show" : ""}`}
          onClick={scrollToTop}
          title="Scroll to Top"
        >
          <i className="fa-solid fa-chevron-up"></i>
        </button>
      </div>
      <div className="inner-wrapper">
        <section role="main" className="page-content">
          <Switch>
            <Route path="/apply/:courseType" component={Registration} />
            <Route path="/page/:pageId" component={webPages} />
            <Route
              path="/instruction/:pageId"
              component={admissionInstructions}
            />

            <Route path="/sign-in" component={login} exact />
            <Route path="/sign-up" component={signUp} exact />
            <Route
              path="/mobile-verification"
              component={MobileVerification}
              exact
            />
            <Route
              path="/registration-success"
              component={RegisterSuccess}
              exact
            />
            <Route path="/home" component={homePage} exact />
            <Route path="*" component={homePage} />
          </Switch>
        </section>
      </div>

      <Footer />
      <AdmissionAlertModal />
    </>
  );
};

export default withRouter(WebLayout);
